import { createAction, props } from "@ngrx/store";
import { UpdateAlarmStatusRequest } from "../../models/requests/update-alarm-status.request";

export const updateAlarm= createAction('[Alarm] Update Alarm', props<{ updateAlarmStatusRequest: UpdateAlarmStatusRequest }>());
export const updateAlarmSuccess = createAction('[Alarm] Update Alarm Success',props<{ equipmentOptions: any[] }>());
export const updateAlarmFailure = createAction('[Alarm] Update Alarm Failure',props<{ error: any }>());